<template>
  <div>
    <div>
      <el-button type="primary" plain @click="addUser">新增</el-button>
      <el-input
        style="width: 200px"
        placeholder="跳转码,用户名筛选"
        v-model="pageListSerach.search"
      ></el-input>
      <el-button @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="pageArr.records">
        <el-table-column align="center" label="跳转码">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="用户名">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>姓名: {{ scope.row.username }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.username }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="密码">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.password }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="第三方来源">
          <template slot-scope="scope">
            <span v-show="scope.row.thirdSource == 1" style="margin-left: 10px"
              >知网CHKJ</span
            >
            <span v-show="scope.row.thirdSource == 2" style="margin-left: 10px"
              >万方</span
            >
            <span v-show="scope.row.thirdSource == 3" style="margin-left: 10px"
              >知网CDMH</span
            >
            <span v-show="scope.row.thirdSource == 4" style="margin-left: 10px"
              >知网CHKDX</span
            >
            <span v-show="scope.row.thirdSource == 5" style="margin-left: 10px"
              >知网CNKI</span
            >
            <span v-show="scope.row.thirdSource == 6" style="margin-left: 10px"
              >EBSCO数据库</span
            >
            <span v-show="scope.row.thirdSource == 8" style="margin-left: 10px"
              >阿帕比图书数据库</span
            >
            <span v-show="scope.row.thirdSource == 9" style="margin-left: 10px"
              >中国疾病知识总库</span
            >
            <span v-show="scope.row.thirdSource == 10" style="margin-left: 10px"
              >医学考试系统</span
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-popconfirm
              title="你确定要删除该条目吗？"
              @onConfirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="danger"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>

            <!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="pageListSerach.pageNo"
      :pageSize="pageArr.pageSize"
      :total="pageArr.total"
    ></page>
    <el-dialog :title="diaName" :visible.sync="dialogVisible" width="60%">
      <el-form :inline="true" ref="form" :model="form" label-width="120px">
        <el-form-item label="跳转码" required>
          <el-input
            v-model="pageArrChange.code"
            required
            placeholder="请填写跳转码"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名" required>
          <el-input
            v-model="pageArrChange.username"
            placeholder="请填写用户名"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item v-if="name == 'admin'" label="用户组">
          <el-select v-model="form.grp" placeholder="请选择">
            <el-option label="超级管理员" :value="1" disabled></el-option>
            <el-option label="省级管理员" :value="2"></el-option>
            <el-option label="普通管理员" :value="3"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item v-if="name == 'admin'" label="是否开启统计">
          <el-switch v-model="form.openStat"></el-switch>
        </el-form-item> -->
        <el-form-item label="密码" required>
          <el-input
            v-model="pageArrChange.password"
            required
            placeholder="请填写密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="第三方来源" required>
          <el-select v-model="pageArrChange.thirdSource" placeholder="请选择">
            <el-option label="知网CHKJ" :value="1"></el-option>
            <el-option label="万方" :value="2"></el-option>
            <el-option label="知网CDMH" :value="3"></el-option>
            <el-option label="知网CHKDX" :value="4"></el-option>
            <el-option label="知网CNKI" :value="5"></el-option>
            <el-option label="EBSCO数据库" :value="6"></el-option>
            <el-option label="阿帕比图书数据库" :value="8"></el-option>
            <el-option label="中国疾病知识总库" :value="9"></el-option>
            <el-option label="医学考试系统" :value="10"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" class="remarkStyle">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="pageArrChange.remark"
            style="width: 335px; height: 40px"
          >
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="真实姓名">
          <el-input v-model="form.realName"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="机构" required>
          <tree-select :treeValue="treeValue" @treeValue="getTree" style="width: 200px" v-if="tree" :option="treeOption"></tree-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
  },
  created() {
    this.getThireLogin();
  },
  mounted() {
    this.name = sessionStorage.getItem("admin");
    if (this.name == "admin") {
      this.grp = 3;
      this.openStat = false;
    } else {
      this.grp = sessionStorage.getItem("grp");
      this.openStat = sessionStorage.getItem("openStat") == 1 ? true : false;
    }
    this.load();
  },
  data() {
    return {
      grp: 0,
      openStat: 0,
      name: "",
      username: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogVisible: false,
      tree: false,
      treeOption: [],
      form: {
        username: "", //用户名
        password: "", //密码
        realName: "", //真实姓名
        orgId: "", //机构ID
        openStat: false,
        grp: 3,
      },
      treeValue: null,
      diaName: "新增用户",

      pageList: {
        pageSize: 10,
        pageNo: 1,
      },
      pageListSerach: {
        pageSize: 10,
        pageNo: 1,
        username: "",
      },
      pageArr: {},
      pageArrChange: {
        code: "",
        remark: "",
        password: "",
        thirdSource: "",
        username: "",
      },
    };
  },
  methods: {
    //   获取页面列表
    getThireLogin() {
      this.$api.thirdLogin(this.pageList).then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          this.pageArr = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    //获取医院code
    getTree(x) {
      this.form.orgId = x;
    },
    //打开新增用户页面，请求树形组件内容
    addUser() {
      this.diaName = "新增用户";
      this.dialogVisible = true;
      this.pageArrChange = {
        code: "",
        remark: "",
        password: "",
        thirdSource: "",
        username: "",
      };
      //   this.$api.thirdLoginChange(this.pageArrChange).then((res) => {
      //     if (res.data.code == 200) {
      //     } else {
      //       this.$message.error(res.data.message);
      //     }
      //   });
    },
    add() {
      if (this.pageArrChange.username == "") {
        this.$message.warning("请填写名称");
      } else if (this.pageArrChange.code == "") {
        this.$message.warning("请填写跳转码");
      } else if (this.pageArrChange.password == "") {
        this.$message.warning("请填写密码");
      } else if (this.pageArrChange.thirdSource == "") {
        this.$message.warning("请填写第三方来源");
      } else if (this.diaName == "新增用户") {
        this.$api.thirdLoginChange(this.pageArrChange).then((res) => {
          if (res.data.code == 200) {
            this.dialogVisible = false;
            this.load();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (this.diaName == "修改用户") {
        this.$api.thirdLoginChange(this.pageArrChange).then((res) => {
          if (res.data.code == 200) {
            this.dialogVisible = false;
            this.load();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
      //   console.log(this.form);
      //   this.$api
      //     .addUpdataUser(this.form)
      //     .then((res) => {
      //       if (res.data.code == 200) {
      //         this.$message({
      //           message: res.data.message,
      //           type: "success",
      //         });
      //         this.load();
      //         this.dialogVisible = false;
      //       } else {
      //         this.$message({
      //           message: res.data.message,
      //           type: "error",
      //         });
      //       }
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
    },
    handleEdit(index, row) {
      this.diaName = "修改用户";
      this.pageArrChange = {
        code: row.code,
        remark: row.remark,
        password: row.password,
        thirdSource: row.thirdSource,
        username: row.username,
        id: row.id,
      };
      this.dialogVisible = true;

      // console.log(index, row);
    },
    //重置密码
    handleRe(index, row) {
      this.$prompt("请输入新密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          // console.log(row.id, value);
          this.$api
            .updatePwd({
              id: row.id,
              password: value,
            })
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });

      console.log(index, row);
    },
    //删除用户
    handleDelete(index, row) {
      console.log("123123");
      this.$api.thirdLoginDelet(row.id).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
      console.log(index, row);
    },
    //是否开启统计
    changeOpenStat(index, row) {
      // console.log(index,row)
      let obj = {
        id: row.id,
        openStat: row.openStat,
      };
      this.$api
        .addUpdataUser(obj)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    load() {
      this.$api.thirdLogin(this.pageListSerach).then((res) => {
        if (res.data.code == 200) {
          this.pageArr = res.data.data;
        }
      });
    },
    getpage(x) {
      console.log(x);
      this.pageListSerach.pageNo = x;
      this.load();
    },
  },
};
</script>

<style lang="scss" scoped></style>
